import { useState } from "react";
import {
  colors,
  breakpoints,
} from "@mytutor/shared-react-web-components/lib/theme";
import { css } from "@emotion/react";
import SubjectLevelPickerDropdown from "../SubjectLevelPickerDropdown";
import PickerDropdown from "../PickerDropdown";
import PriceFilter from "../PriceFilter";
import AvailabilityFilter from "../AvailabilityFilter";
import TutorCategoryFilter from "../TutorCategoryFilter";

// eslint-disable-next-line sonarjs/cognitive-complexity
const SearchFilter = ({ subjectAndLevel, urlParameters }) => {
  const [moreFilter, setMoreFilter] = useState(false);

  const searchFilterStyle = css`
    @media (min-width: ${breakpoints.phone}px) {
      position: sticky;
    }
    top: 4em;
    z-index: 10;
    background-color: ${colors.bgcolor1};

    .listview__filters {
      display: flex;
      height: auto;
      flex-direction: column;
      padding: 0;
      border-bottom: 0;
      background-color: ${colors.bgcolor1};
      @media (max-width: ${breakpoints.tablet}px) {
        padding: 1em;
      }
      @media (min-width: ${breakpoints.tablet}px) {
        border-radius: 8px;
        flex-direction: row;
        padding-bottom: 1em;
      }
      @media (min-width: ${breakpoints.desktop}px) {
        height: ${moreFilter ? "230px" : "90px"};
        transition: height 0.3s ease-in;
        
      }

      .column.filter-priority-2 {
        @media (min-width: ${breakpoints.tablet}px and max-width: ${breakpoints.desktop}px) {
          height: ${moreFilter ?  "auto" : "1px"};
          overflow: ${moreFilter ?  "visible" : "hidden"};
          transition: all 0.3s ease-in;
        }
      }

      .column.filter-priority-3 {
        @media (min-width: ${breakpoints.desktop}px) {
          height: ${moreFilter ?  "auto" : "1px"};
          overflow: ${moreFilter ?  "visible" : "hidden"};
          transition: all 0.3s ease-in;
        }
      }
    }

    .listview__filters__tile {
      display: flex;
      flex-wrap: wrap;
      width: 100%;
    }
    .listview__filters_more {
      min-width: 107px;
      display: flex;
      white-space: nowrap;
      @media (min-width: ${breakpoints.tablet}px) {
        width: 15%;
      }
      p {
        cursor: pointer;
        margin: 8px auto 0;
        padding-right: 22px;
        font-size: 18px;
        font-weight: 500;
        color: ${colors.primary8};
        transition: 0.2s;
        :hover {
          color: ${colors.primary7};
        }
        @media (min-width: ${breakpoints.tablet}px) {
          margin: 35px auto 0;
        }

        ::after {
          content: url(/view-tutors/chevron-vertical-primary8.svg);
          position: absolute;
          padding: ${moreFilter ? "4px 7px" : "0px 7px"};
          transition-property: transform;
          transform: ${moreFilter ? "rotate(-180deg)" : ""};
          transition-duration: 0.2s;
        }
      }
    }
    .column {
      flex: 1;
      flex-basis: 100%;
      padding-bottom: 10px;
      max-width: 100%;
      @media (min-width: ${breakpoints.phone}px) {
        flex-basis: 50%;
        max-width: 50%;
        padding-right: 10px;
      }
      @media (min-width: ${breakpoints.tablet}px) {
        flex-basis: 33%;
        max-width: 33%;
        padding-right: 10px;
        padding-bottom: 0;
      }
    }
    .column-prices {
      display: ${moreFilter ? "block" : "none"};
      @media (min-width: ${breakpoints.tablet}px) {
        display: block;
      }
      @media (min-width: ${breakpoints.desktop}px) {
        display: block;
      }
    }
    .column-gender,
    .column-availability {
      display: ${moreFilter ? "block" : "none"};
      @media (min-width: ${breakpoints.tablet}px) {
        padding-top: 10px;
      }
      @media (min-width: ${breakpoints.desktop}px) {
        display: block;
        visibility: ${moreFilter ? "visible" : "hidden"};
        opacity: ${moreFilter ? "1" : "0"};
        transition: ${moreFilter
          ? "opacity 0.3s ease-in 0.3s"
          : "opacity 0.2s ease-in"};
      }
    }
    .column-additional-subject {
      display: ${moreFilter ? "block" : "none"};
      display: none; //hide until functional
    }
    .column-category {
      display: ${moreFilter ? "block" : "none"};
      @media (min-width: ${breakpoints.tablet}px) {
        padding-top: 10px;
      }
      @media (min-width: ${breakpoints.desktop}px) {
        display: block;
        visibility: ${moreFilter ? "visible" : "hidden"};
        opacity: ${moreFilter ? "1" : "0"};
        transition: ${moreFilter
          ? "opacity 0.3s ease-in 0.3s"
          : "opacity 0.2s ease-in"};
      }
    }
  `;

  const gendersOptions = [
    {
      label: "Men",
      value: "Male",
    },
    {
      label: "Women",
      value: "Female",
    },
  ];

  return (
    <main id="tutor-filters" css={searchFilterStyle} data-test="search-filter">
      <div className="row">
        <div className="listview__filters">
          <div className="listview__filters__tile">
            <div className="column column-subjects">
              Subject
              <SubjectLevelPickerDropdown
                filter="subject"
                subjectAndLevel={subjectAndLevel}
              />
            </div>
            <div></div>
            <div className="column column-levels">
              Level
              <SubjectLevelPickerDropdown
                filter="level"
                subjectAndLevel={subjectAndLevel}
              />
            </div>
            <div className="column column-prices filter-priority-2">
              Price
              <PriceFilter urlParameters={urlParameters} />
            </div>
            <div className="column column-gender filter-priority-3">
              Gender
              <PickerDropdown
                filter="gender"
                FilterOptions={gendersOptions}
                urlParameters={urlParameters}
              />
            </div>
            <div className="column column-availability filter-priority-3">
              Availability
              <AvailabilityFilter urlParameters={urlParameters} />
            </div>
            <div className="column column-category filter-priority-3">
              Tutor categories
              <TutorCategoryFilter urlParameters={urlParameters} />
            </div>
          </div>
          <div className="listview__filters_more">
            <p onClick={() => setMoreFilter(!moreFilter)}>
              {moreFilter ? "Close filters" : "More filters"}
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SearchFilter;
